<template>
  <div class="section d-flex flex-column justify-content-between">
    <div class="my-slide">
      <div
        class="external"
        v-for="(item, i) in carousel_items"
        :key="i"
        :class="active_item == i ? 'active' : ''"
      >
        <div
          class="item"
          :style="{ backgroundImage: 'url(' + item + ')' }"
        ></div>
      </div>
    </div>
    <div
      class="my-controls d-flex align-items-center justify-content-between mt-3"
    >
      <div class="my-prev pointer d-flex align-items-center" @click="prev()">
        <i class="fas fa-chevron-left"></i>
      </div>
      <div class="my-dots">
        <i
          v-for="(dot, i) in carousel_items.length"
          :key="i"
          :class="i == active_item ? 'fas' : 'far'"
          class="fa-circle dot"
          @click="select_item(i)"
        ></i>
      </div>

      <div class="my-next pointer d-flex align-items-center" @click="next()">
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gallery.vue",
  props: ["carousel_items"],

  components: {},
  data() {
    return {
      move: 0,
      active_item: 0,
      windowWidth: window.innerWidth,
      txt: "",
      moveStep: null,
    };
  },
  watch: {
    windowWidth(newWidth, oldWidth) {
      this.txt = `it changed to ${newWidth} from ${oldWidth}`;
      // console.log(this.txt);
      if (newWidth > 1200) {
        this.moveStep = 32;
      } else if (newWidth > 576 && newWidth <= 1200) {
        this.moveStep = 48;
      } else if (newWidth <= 576) {
        this.moveStep = 85; // verificare ipad
      }
    },
  },
  mounted() {
    var width = $(window).width();
    if (width > 1200) {
      this.moveStep = 32;
    } else if (width > 576 && width <= 1200) {
      this.moveStep = 48;
    } else if (width <= 576) {
      this.moveStep = 85; // verificare ipad
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    select_item: function (i) {
      this.active_item = i;
      this.move = this.moveStep * i;
    },

    onResize() {
      this.windowWidth = window.innerWidth;
      this.move = 0;
      this.active_item = 0;
    },
    prev: function () {
      if (this.active_item == 0) {
        this.active_item = this.carousel_items.length - 1;
        this.move = this.moveStep * (this.carousel_items.length - 1);
      } else {
        this.active_item -= 1;
        this.move -= this.moveStep;
      }
     // console.log(this.move);
    },
    next: function () {
      if (this.active_item == this.carousel_items.length - 1) {
        this.move = 0;
        this.active_item = 0;
      } else {
        this.move += this.moveStep;
        this.active_item += 1;
      }
     // console.log(this.move);
    },
  },
};
</script>

<style lang="scss" scoped>
.my-dots {

  .dot {
    margin: 0 10px;
  }
}

.my-controls {
  span {
    margin: 0 10px;
  }
}
.section{
  padding: 0;
 // border: 1px solid red;
  width: 100%;
}
.my-slide {
  width: 100%;
  height: 100%;
  //margin-left: -1vw;
  transition: all 0.5s ease-in-out 0s;
  .external {
    width: 100%;
    display: none;
    &.active {
      display: block;
    }
    .item {
      position: relative;
      padding-top: 66%;
      width: 100%;
      display: inline-block;
      background-size: cover;
      background-color: #000;
    }
  }
}

@media (min-width: 576px) {
}

@media (min-width: 1200px) {
}
</style>